import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChipSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChipSimple"><Path d="M14.5 14.5H9.5V9.5H14.5V14.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M10.5 3H13.5V1H15V3H21V9H23V10.5H21V13.5H23V15H21V21H15V23H13.5V21H10.5V23H9V21H3V15H1V13.5H3V10.5H1V9H3V3H9V1H10.5V3ZM8 16H16V8H8V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChipSimple;
